import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class OrçamentosPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaControle, buscaPessoa, buscaUsuario, buscaOrdem } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        axios
            .get('/orcamentos', {
                params: {
                    print: true,
                    campoOrdem: buscaOrdem.campo,
                    tipoOrdem: buscaOrdem.ordem,
                    numero: buscaControle,
                    pessoa: buscaPessoa.key,
                    usuario: buscaUsuario.key,
                    dataIni,
                    dataFim,
                }
            })
            .then(response => {
                const { data } = response;
                this.setState({
                    listaRegistros: data.dados,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (vlr, registro) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderSitOS = (sit) => {
        return (
            <span> {sit === 'ABE' ? 'ABERTO' : (sit === 'ESP' ? 'ESPERA' : (sit === 'APR' ? 'APROVADO' : (sit === 'FEC' ? 'FECHADO' : '')))} </span>
        );
    };

    renderSitFinanc = (sit) => {
        return (
            <span> {sit === 'P' ? 'PAGO' : 'ABERTO'} </span>
        );
    };

    renderNome = (nome, registro) => {
        return (
            <span> {registro.orc_nome_cliente ? registro.orc_nome_cliente : registro.pes_nome} </span>
        );
    };




    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Orçamentos
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                <span style={{ fontWeight: "bold" }}>Qtde: </span>
                                <span>{this.props.qtdeOS}</span>

                                <span style={{ fontWeight: "bold", marginLeft: 50 }}>Valor Total: </span>
                                <span>R$ {this.renderValor(this.props.totalOS)}</span>
                            </Col>
                        </Row>

                        <Table
                            pagination={false}
                            dataSource={listaRegistros}
                            className="tabela"
                            rowKey={(listaRegistros => listaRegistros.orc_idf)}
                            loading={{
                                spinning: carregando,
                                tip: 'Carregando. Aguarde...',
                                size: "large"
                            }}
                        >
                            <Column
                                key="orc_numero"
                                dataIndex="orc_numero"
                                title="Número"
                                width={80}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="orc_data_emissao"
                                dataIndex="orc_data_emissao"
                                title="Emissão"
                                render={this.renderData}
                                width={150}
                                align="center"
                                className="listaCadastro"
                            />
                            <Column
                                key="pes_nome"
                                dataIndex="pes_nome"
                                title="Cliente"
                                render={this.renderNome}
                                width={150}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="orc_descricao"
                                dataIndex="orc_descricao"
                                title="Descrição"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="usu_nome"
                                dataIndex="usu_nome"
                                title="Vendedor"
                                width={100}
                                align="left"
                                className="listaCadastro"
                            />
                            <Column
                                key="orc_vlr_total"
                                dataIndex="orc_vlr_total"
                                title="Valor Total"
                                render={this.renderValor}
                                width={90}
                                align="right"
                                className="listaCadastro"
                            />
                            <Column
                                key="orc_situacao"
                                dataIndex="orc_situacao"
                                title="Situação"
                                render={this.renderSitOS}
                                width={100}
                                align="center"
                                className="listaCadastro"
                            />
                        </Table>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default OrçamentosPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OrçamentosPrintModal.js